import { ProctoringSessionSummary } from "@verity/api-client/types";
import { CoreButton } from "@verity/components/core";
import i18n from "../../../../../i18n";
import { AiSummaryButton } from "../Summary";

type SummaryButtonProps = {
	loading?: boolean;
	sessionSummary?: ProctoringSessionSummary;
	isLiveSessionProctor?: boolean;
	showSummary: () => void;
	showAiSummary: () => void;
};

export default function SummaryButton(props: SummaryButtonProps) {
	const { loading, sessionSummary, isLiveSessionProctor, showSummary, showAiSummary } = props;

	if (loading) return null;

	if (sessionSummary?.source === "liveProctor" || isLiveSessionProctor) {
		return (
			<CoreButton onClick={showSummary}>
				{isLiveSessionProctor && sessionSummary?.source !== "liveProctor"
					? i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.addSummary")
					: i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.viewSummary")}
			</CoreButton>
		);
	}

	return <AiSummaryButton summaryExists={!!sessionSummary} onClick={showAiSummary} />;
}
